import { PunchupTicketDetails } from 'features/PunchupPages/TicketDetails';
import { PunchupTicketDetails as LegacyPunchupTicketDetails } from 'features/PunchupTicketDetails';
import { TicketDetails as TicketDetailsComponent } from 'features/TicketDetails';
import { useAppSelector } from 'store/hooks';

const TicketDetails = (): JSX.Element => {
	const { isPunchup, greenZoneEnabled } = useAppSelector((state) => state.auth);

	if (isPunchup && greenZoneEnabled) return <PunchupTicketDetails />;
	if (isPunchup) return <LegacyPunchupTicketDetails />;
	return <TicketDetailsComponent />;
};
export default TicketDetails;
